import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthService } from './services/AuthService';

/**
 * Hook to handle authentication state and navigation
 * This runs on every route change to ensure user is on the correct page
 * Data fetching is handled separately by useHomeData hook
 */
const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    AuthService.checkAuthAndNavigate(navigate, location);
  }, [navigate, location.pathname, location.search]);
};

export default useAuth;
